import React, { useState, useEffect } from "react";

import { styles } from "../styles/AIAssistantForm.styles";
import { useAuth } from "../context/AuthContext";
import Select from "react-select";
import {MdSmartToy,MdArrowBack,MdSave,MdDelete,MdVisibility,MdVisibilityOff,MdPolicy,MdWarning,MdReceiptLong } from "react-icons/md";
import { FaDatabase } from "react-icons/fa";
import { IoReceiptSharp } from "react-icons/io5";
import { updateIAConfig,deleteIAConfig,getIALogs} from "../services/ia";
import { useNavigate } from "react-router-dom";

function EditIAPage({ setActiveMenu, ia }) {
  const { token } = useAuth();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  const assistantTypes = [
    { value: "apolices", label: "Apólices", icon: MdPolicy },
    { value: "recibos", label: "Recibos", icon: IoReceiptSharp }
    ];
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const [formData, setFormData] = useState({
    nome: ia?.NOME || "",
    foto: null,
    fotoPreview: ia?.FOTO || null,
    tipoAssistente: ia?.FUNCAO || "chatbot",
    tag: ia?.TAG ? String(ia.TAG).replace(/^@+/, "") : "",
    apiKey: ia?.API_KEY || "",
    descricao: ia?.DESCRICAO || "",
  });

  const [showApiKey, setShowApiKey] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [imageLoading, setImageLoading] = useState(!formData.fotoPreview);
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes spinModern {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .spin-modern {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid rgba(0,0,0,0.1);
        border-top: 2px solid #ebeaea;
        animation: spinModern 0.8s linear infinite;
      }

      @keyframes shimmer {
        0% { background-position: -1000px 0; }
        100% { background-position: 1000px 0; }
      }

      .shimmer {
        background: linear-gradient(
          90deg,
          #f0f0f0 0%,
          #e0e0e0 50%,
          #f0f0f0 100%
        );
        background-size: 1000px 100%;
        animation: shimmer 2s infinite;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "tag" ? value.replace(/^@+/, "") : value;
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const formatAssistantOption = ({ label, icon: Icon }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    {Icon && <Icon size={18} color="#6b7280" />}
    <span>{label}</span>
  </div>
);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData((prev) => ({
          ...prev,
          foto: file,
          fotoPreview: event.target.result,
        }));
        setImageLoading(true);
      };
      reader.readAsDataURL(file);
      if (errors.foto) {
        setErrors((prev) => ({
          ...prev,
          foto: null,
        }));
      }
    }
  };

  const removeFoto = () => {
    setFormData((prev) => ({
      ...prev,
      foto: null,
      fotoPreview: null,
    }));
  };

  const handleBack = () => {
    navigate("/ais");
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const result = await updateIAConfig({
        STAMP: ia.STAMP,
        NOME: formData.nome,
        FUNCAO: formData.tipoAssistente,
        FOTO: formData.foto,
        TAG: formData.tag && String(formData.tag).startsWith("@") ? formData.tag : `@${formData.tag}`,
        API_KEY: formData.apiKey,
        DESCRICAO: formData.descricao,
      });

      // If API returns structured failure, show error and stay on form
      if (result && result.success === false) {
        setErrors({ tag: result.message || "Erro ao atualizar assistente" });
        setLoading(false);
        return;
      }

      navigate("/ais");

    } catch (err) {
      console.error(err);

    } finally {
      setLoading(false);
    }
   };


 const loadLogs = async () => {
  try {
    setLogsLoading(true);


    const result = await getIALogs(ia?.STAMP, 10);
    setLogs(result.logs || []);

  } catch (err) {
    console.error("Erro ao carregar logs:", err);
  } finally {
    setLogsLoading(false);
  }
};

useEffect(() => {
  if (ia?.STAMP) {
    loadLogs();
  }
}, [ia?.STAMP]);

 

  const handleDelete = async () => {
    try {
        setLoading(true);

        const result = await deleteIAConfig(ia?.STAMP);

        setShowDeleteModal(false);
        navigate("/ais");

    } catch (err) {
        console.error("Erro ao eliminar assistente:", err);
        alert("Erro ao eliminar assistente");

    } finally {
        setLoading(false);
    }
};

  return (
    <div style={styles.container(isMobile)}>
      <div style={styles.headerSection(isMobile)}>
        <button
          onClick={handleBack}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#1f3a70",
            fontSize: 28,
            padding: 0,
            marginRight: 12,
          }}
        >
          <MdArrowBack size={28} />
        </button>

        <div style={styles.iconBadge}>
          <MdSmartToy size={24} />
        </div>

        <div>
          <h1 style={styles.title}>Editar Assistente</h1>
          <p style={styles.subtitle}>
            Atualize os detalhes do assistente de IA
          </p>
        </div>
      </div>

      <div style={styles.formWrapper(isMobile)}>
        <form style={styles.form}>
          {/* Nome */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Nome</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleInputChange}
              placeholder="Ex: Gemese IA, SuperBot..."
              style={styles.input}
              disabled={loading}
            />
            {errors.nome && (
              <span style={styles.errorText}>{errors.nome}</span>
            )}
          </div>

          {/* Foto */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Foto</label>
            <div style={styles.photoSection}>
              {formData.fotoPreview ? (
                <div style={styles.photoPreviewWrapper(isMobile)}>
                  {imageLoading && (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        borderRadius: 12,
                        zIndex: 1,
                      }}
                      className="shimmer"
                    />
                  )}
                  <img
                    src={formData.fotoPreview}
                    alt="Preview"
                    style={{
                      ...styles.photoPreview(isMobile),
                      opacity: imageLoading ? 0.5 : 1,
                      transition: "opacity 0.3s ease",
                    }}
                    onLoad={() => setImageLoading(false)}
                    onError={() => setImageLoading(false)}
                  />
                  <button
                    type="button"
                    onClick={removeFoto}
                    style={styles.removePhotoButton}
                    disabled={loading}
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <label htmlFor="photoInput" style={styles.photoPlaceholder}>
                  <svg
                    style={styles.uploadIcon}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>

                  <p style={styles.photoPlaceholderText}>
                    Clique para enviar
                  </p>
                </label>
              )}

              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={styles.hiddenFileInput}
                id="photoInput"
                disabled={loading}
              />
            </div>
            {errors.foto && (
              <span style={styles.errorText}>{errors.foto}</span>
            )}
          </div>

            {/* Tipo de Assistente */}
            <div style={styles.formGroup}>
            <label style={styles.label}>Tipo de Assistente</label>

            <Select
                value={assistantTypes.find(
                (o) => o.value === formData.tipoAssistente
                )}
                onChange={(selected) =>
                setFormData((prev) => ({
                    ...prev,
                    tipoAssistente: selected?.value || "",
                }))
                }
                options={assistantTypes}
                formatOptionLabel={formatAssistantOption}
                isSearchable={false}
                styles={{
                control: (base) => ({
                    ...base,
                    borderRadius: 8,
                    borderColor: "#ccc",
                    minHeight: 42,
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                }),
                }}
                isDisabled={loading}
            />

            {errors.tipoAssistente && (
                <span style={styles.errorText}>
                {errors.tipoAssistente}
                </span>
            )}
            </div>

          {/* Tag */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Tag</label>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ padding: "8px 12px", background: "#f3f4f6", borderRadius: 6, border: "1px solid #e5e7eb" }}>@</span>
              <input
                type="text"
                name="tag"
                value={formData.tag}
                onChange={handleInputChange}
                placeholder="Ex: IA"
                style={{ ...styles.input, paddingLeft: 8 }}
                disabled={loading}
              />
            </div>
            {errors.tag && (
              <span style={styles.errorText}>{errors.tag}</span>
            )}
          </div>

          
          {/* API Key */}
            <div style={styles.formGroup}>
            <label style={styles.label}>API Key</label>

            <div style={styles.passwordInputWrapper}>
                <input
                  type={showApiKey ? "text" : "password"}
                  name="apiKey"
                  value={formData.apiKey}
                  onChange={handleInputChange}
                  placeholder="Insira a API Key"
                  style={styles.input}
                  disabled={loading}
                />

                <button
                  type="button"
                  onClick={() => setShowApiKey((prev) => !prev)}
                  style={styles.passwordToggleButton}
                  disabled={loading}
                  aria-label={
                    showApiKey ? "Ocultar API Key" : "Mostrar API Key"
                  }
                >
                  {showApiKey ? (
                    <MdVisibilityOff size={20} />
                  ) : (
                    <MdVisibility size={20} />
                  )}
                </button>
            </div>

            {errors.apiKey && (
                <span style={styles.errorText}>
                {errors.apiKey}
                </span>
            )}
            </div>

          {/* Descrição */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Descrição</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleInputChange}
              placeholder="Descreva o propósito e funcionalidades do assistente..."
              style={styles.textarea}
              disabled={loading}
            />
            {errors.descricao && (
              <span style={styles.errorText}>{errors.descricao}</span>
            )}
          </div>

          {/* Botões */}
          <div style={styles.buttonGroup(isMobile)}>
            <button
                type="button"
                onClick={() => setShowDeleteModal(true)}
                style={{
                    ...styles.cancelButton(isMobile),
                    background: "#ef4444",
                    color: "#fff",
                }}
                disabled={loading}
                >
                <MdDelete size={16} style={{ marginRight: 6 }} />
                Eliminar
            </button>
          
            <button
              type="button"
              onClick={handleSave}
              style={{
                ...styles.submitButton(isMobile),
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spin-modern" />
                  A guardar...
                </>
              ) : (
                <>
                  <MdSave size={16} />
                  Guardar
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      {showDeleteModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
      padding: 20,
      backdropFilter: "blur(3px)",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: 420,
        background: "#fff",
        borderRadius: 20,
        padding: 28,
        boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        animation: "fadeIn 0.2s ease",
      }}
    >
      <div
        style={{
          width: 70,
          height: 70,
          borderRadius: "50%",
          background: "#fee2e2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 18px auto",
        }}
      >
        <MdWarning size={38} color="#dc2626" />
      </div>

      <h2
        style={{
          textAlign: "center",
          fontSize: 22,
          fontWeight: 700,
          color: "#111827",
          marginBottom: 12,
        }}
      >
        Eliminar Assistente
        </h2>

        <p
            style={{
            textAlign: "center",
            color: "#6b7280",
            lineHeight: 1.6,
            marginBottom: 28,
            fontSize: 15,
            }}
        >
            Tem a certeza que deseja eliminar o assistente{" "}
            <strong>{formData.nome}</strong>?
            <br />
            Esta ação não pode ser revertida.
        </p>

        <div
            style={{
            display: "flex",
            gap: 12,
            }}
        >
            <button
            type="button"
            onClick={() => setShowDeleteModal(false)}
            disabled={loading}
            style={{
                flex: 1,
                height: 46,
                borderRadius: 12,
                border: "1px solid #d1d5db",
                background: "#fff",
                color: "#374151",
                fontWeight: 600,
                cursor: "pointer",
            }}
            >
            Cancelar
            </button>

            <button
            type="button"
            onClick={handleDelete}
            disabled={loading}
            style={{
                flex: 1,
                height: 46,
                borderRadius: 12,
                border: "none",
                background: "#dc2626",
                color: "#fff",
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                opacity: loading ? 0.7 : 1,
            }}
            >
            {loading ? (
              <>
                <div className="spin-modern" />
                A eliminar...
              </>
            ) : (
              <>
                <MdDelete size={18} />
                Eliminar
              </>
            )}
            </button>
        </div>
        </div>
    </div>
    )}

    {/* LOGS */}
<div style={{ marginTop: 32 }}>

  {/* HEADER */}
  <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>

    <div style={styles.iconBadge}>
      <FaDatabase size={24} />
    </div>

    <div>
      <h1 style={styles.title}>Pedidos Processados</h1>
      <p style={styles.subtitle}>
        Pedidos processados pelo assistente de IA
      </p>
    </div>

  </div>

  {/* CONTENT */}
  {logsLoading ? (
    <div style={{ color: "#6b7280", fontSize: 14 }}>
      A carregar logs...
    </div>
  ) : logs.length === 0 ? (
    <div
      style={{
        color: "#9ca3af",
        fontSize: 14,
        padding: 12,
        background: "#f9fafb",
        borderRadius: 10,
        border: "1px dashed #e5e7eb"
      }}
    >
      Sem logs disponíveis
    </div>
  ) : (
   <div
      style={{
        border: "1px solid #ffffff", 
        borderRadius: 14,
        overflow: "hidden",
        background: "#fff",
      }}
    >

      {!isMobile && (
        <div
          style={{
            display: "flex",
            padding: "10px 18px",
            fontSize: 12,
            fontWeight: 700,
            color: "#5d6f8a",
            textTransform: "uppercase",
            letterSpacing: 0.5,
            borderBottom: "1px solid rgba(31, 58, 112, 0.08)",
          }}
        >
          <div style={{ flex: 1, fontWeight: 600 }}>Pedido</div>

          <div style={{ flex: 3, fontWeight: 600 }}>
            Destinatário
          </div>

          <div
            style={{
              flex: 2,
              fontWeight: 600,
              display: "flex",
              justifyContent: "start",
            }}
          >
            Estado
          </div>

          <div
            style={{
              flex: 1,
              fontWeight: 600,
              display: "flex",
              justifyContent: "start",
            }}
          >
            Data
          </div>
        </div>
      )}

      {logs.map((log, index) => {
        const isError =
          log.ESTADO?.toLowerCase?.() === "erro" ||
          log.ESTADO?.toLowerCase?.() === "error";
        const formattedDate = log.CRIADO_EM
          ? new Date(log.CRIADO_EM)
              .toLocaleDateString("pt-PT")
              .replace(/\//g, "-")
          : "";

        return (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "flex-start" : "center",
              gap: isMobile ? 12 : 0,
              padding: "14px 18px",
              borderBottom: "1px solid rgba(31, 58, 112, 0.06)",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              if (!isMobile) {
                e.currentTarget.style.backgroundColor = "#f3f6ff";
              }
            }}
            onMouseLeave={(e) => {
              if (!isMobile) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
          >
            <div
              style={{
                flex: isMobile ? "unset" : 1,
                minWidth: 0,
                width: isMobile ? "100%" : undefined,
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 13,
                  color: "#15233c",
                  lineHeight: 1.4,
                  marginBottom: isMobile ? 8 : 0,
                  whiteSpace: isMobile ? "normal" : "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {log.MENSAGEM || log.PROMPT || "Sem mensagem"}
              </div>
            </div>

            <div
              style={{
                flex: isMobile ? "unset" : 3,
                minWidth: 0,
                width: isMobile ? "100%" : undefined,
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#334155",
                  whiteSpace: isMobile ? "normal" : "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={log.NOME_DESTINO}
              >
                {log.NOME_DESTINO || "—"}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flex: isMobile ? "unset" : 2,
                justifyContent: isMobile ? "flex-start" : "start",
                width: isMobile ? "100%" : undefined,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  padding: "4px 8px",
                  borderRadius: 999,
                  background: isError
                    ? "#fee2e2"
                    : log.ESTADO?.toLowerCase?.() === "pendente"
                    ? "#fef3c7"
                    : "#dcfce7",
                  color: isError
                    ? "#b91c1c"
                    : log.ESTADO?.toLowerCase?.() === "pendente"
                    ? "#b45309"
                    : "#15803d",
                  whiteSpace: "nowrap",
                }}
              >
                {log.ESTADO || "INFO"}
              </span>
            </div>

            <div
              style={{
                flex: isMobile ? "unset" : 1,
                display: "flex",
                justifyContent: isMobile ? "flex-start" : "start",
                fontSize: 12,
                fontWeight: 600,
                color: "#1f3a70",
                width: isMobile ? "100%" : undefined,
              }}
            >
              {formattedDate}
            </div>
          </div>
        );
      })}
    </div>
  )}
</div>



    </div>
  );
}

export default EditIAPage;
